import React from "react";
import styles from "./CartList.module.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { NavLink } from 'react-router-dom';
import { allProducts } from "../../../API/ProductsAPI";

const CartList = ({ cart, setCart }) => {
  const isMobile = (window.innerWidth <= 768) ? true : false;

  const onRemoveProduct = (id) => {
    setCart((prevProducts) => prevProducts.filter((product) => product.id !== id));
  }

  const onIncrement = (id) => {
    setCart((prevProducts) =>
      prevProducts.map((product) =>
        product.id === id
          ? { ...product, quantity: product.quantity + 1 }
          : product
      )
    );
  };

  const onDecrement = (id) => {
    setCart((prevProducts) =>
      prevProducts.map((product) =>
        product.id === id && product.quantity > 0
          ? { ...product, quantity: product.quantity - 1 }
          : product
      )
        .filter((product) => product.quantity > 0)
    );
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.productColumn}>Produs</th>
          <th className={styles.centered} >Cantitate</th>
          <th className={styles.priceCol} >Preț</th>
          {isMobile || <th></th>}
        </tr>
      </thead>
      <tbody>
        {cart.map((product, index) => (
          <tr key={index} className={styles.row}>
            <td className={styles.productDetails}>
              <img src={allProducts[product.id].image} alt={product.name} className={styles.productImage} />
              <div className={styles.product}>
                <NavLink to={`/product/${product.id}`} className={styles.name} >{`${allProducts[product.id].name} ( ${allProducts[product.id].prices[product.priceIndex].power} )`}</NavLink>
                {isMobile || <div className={styles.description}>{allProducts[product.id].short_description}</div>}
              </div>
            </td>
            <td className={styles.quantity}>
              <div className={styles.quantityContainer}>
                <div className={styles.button}>
                  <i className="fa-solid fa-minus" onClick={() => onDecrement(product.id)} />
                </div>
                <div className={styles.quantityValue}>{product.quantity}</div>
                <div className={styles.button}>
                  <i className="fa-solid fa-plus" onClick={() => onIncrement(product.id)} />
                </div>
              </div>
            </td>
            <td className={styles.price}>{`${allProducts[product.id].prices[product.priceIndex].price.toLocaleString()} €`}</td>
            {isMobile || <td>
              <div className={styles.removeBtn} onClick={() => onRemoveProduct(product.id)}>
                <i className="fa-regular fa-trash-can" />
              </div>
            </td>}
          </tr>
        ))}
      </tbody>
    </table >
  );
};

export default CartList;
